import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Alert
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import Papa from 'papaparse';

const ExportCardsDialog = ({ open, onClose, cards, boardName, boardId }) => {
  const handleExport = () => {
    // Transform cards data to match the import format
    const exportData = cards.map(card => ({
      CardNumber: card.cardId || card.id || '', // Added CardNumber field
      Summary: card.taskName || '',
      Description: card.description || '',
      CardStatus: card.cardStatus || '',
      DueDate: card.dueDate || '',
      CardType: card.cardType || '',
      Priority: card.priority || '',
      AcceptanceCriteria: card.acceptanceCriteria || '',
      Estimate: card.estimate || '',
      AssigneeName: card.assigneeName || '',
      ProjectName: card.cardProjectName || '', //Added ProjectName field to exportcards
      AssignedBoard: boardName || '' // Added AssignedBoard field
     
    }));

    // Convert to CSV
    const csv = Papa.unparse(exportData);
    
    // Create and download file
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'cards_export.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Export Cards to CSV</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            This will export all cards in the current board to a CSV file. The exported file will include all card details and can be used for backup or import into other systems.
          </Typography>
          <Alert severity="info" sx={{ mb: 2 }}>
            The export will include {cards.length} cards.
          </Alert>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleExport}
          variant="contained"
          color="primary"
          startIcon={<DownloadIcon />}
        >
          Export Cards
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportCardsDialog; 